import React from 'react';
import classNames from 'classnames';

import EyeIcon from '@geobank/assets/src/icons/EyeIcon';
import EyeHiddenIcon from '@geobank/assets/src/icons/EyeHiddenIcon';

import styles from './PasswordInput.css';

interface InputPasswordProps {
  className?: string;
  placeholder?: string;
  width?: string;
  height?: string;
  fontSize?: string;
  value?: string;
  onChange?: (fieldName: string, value: string) => void;
  // inputProps: {id, name}
  id?: string;
  name?: string;
  error?: string;
}

interface InputPasswordState {
  inputType: string;
  // iconType: JSX.Element;
  inputValue: string;
  isHidden: boolean;
}

export default class InputPassword extends React.Component<InputPasswordProps, InputPasswordState> {
  constructor({ props }: { props: any }) {
    super(props);
    this.state = {
      inputType: 'password',
      // iconType: EyeHiddenIcon(),
      inputValue: '',
      isHidden: true,
    };
  }

  private readonly changeIconTypeMouseDown = () => {
    this.setState({ inputType: 'text', isHidden: false });
  };

  private readonly changeIconTypeMouseUp = () => {
    this.setState({ inputType: 'password', isHidden: true });
  };

  private readonly passwordHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const fieldName = event.target.name || event.target.id;
    const value = event.target.value;

    this.setState({ inputValue: value });
    const { onChange } = this.props;
    if (onChange !== undefined) {
      onChange(fieldName, value);
    }
  };

  public componentDidMount() {
    const { value } = this.props;
    if (value) {
      this.setState({ inputValue: value });
    }
  }

  public render() {
    const { className, placeholder, width, height, fontSize, id, name, error } = this.props;
    const { inputType, inputValue, isHidden } = this.state;

    return (
      <div className={classNames(styles.root, className)} style={{ width /*, height*/ }}>
        <div className={styles.input_password__container}>
          <input
            type={inputType}
            placeholder={placeholder}
            className={classNames(styles.input_password, { [styles.error_input]: error })}
            style={{ width: '100%', height, fontSize }}
            onChange={this.passwordHandler}
            value={inputValue}
            {...{ id, name }}
          />
          <div className={styles.input_password__icon}>
            <button
              className={styles.input_password__button}
              onMouseDown={this.changeIconTypeMouseDown}
              onMouseUp={this.changeIconTypeMouseUp}
              onMouseLeave={this.changeIconTypeMouseUp}
            >
              {isHidden ? <EyeHiddenIcon /> : <EyeIcon />}
            </button>
          </div>
        </div>
        {error && <p className={styles.error_msg}>{error}</p>}
      </div>
    );
  }
}
